import { render } from "./navigation-item.vue?vue&type=template&id=53a66d5d&scoped=true"
import script from "./navigation-item.vue?vue&type=script&lang=js"
export * from "./navigation-item.vue?vue&type=script&lang=js"

import "./navigation-item.vue?vue&type=style&index=0&id=53a66d5d&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53a66d5d"]])

export default __exports__